<template>
  <Modal
    :title="$t('appointment.closeModal.title')"
    name="CONFIRM_CLOSE_APPOINTMENT_MODAL"
    actions
  >
    <template v-slot:body>
      <v-card class="pa-5" color="orange lighten-5" elevation="0">
        <span class="orange--text">
          {{ $t('appointment.closeModal.text') }}
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('CONFIRM_CLOSE_APPOINTMENT_MODAL')"
        elevation="0"
        color="grey"
        text
      >
        {{ $t('appointment.closeModal.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="closeCreateModal"
        color="orange"
        elevation="0"
        class="ml-5"
        dark
      >
        {{ $t('appointment.closeModal.buttons.closeModal') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalConfirmToClose',

  components: {
    Modal,
  },

  methods: {
    ...mapActions(['closeModal']),

    closeCreateModal() {
      const createAppointmentModal = this.$root?.$children[0].$refs?.createAppointmentModal
      if (!createAppointmentModal) return

      this.closeModal('CONFIRM_CLOSE_APPOINTMENT_MODAL')
      createAppointmentModal.handleResetForm()
      createAppointmentModal.closeModal()
    },
  },
}
</script>
